module.exports = __webpack_public_path__ + "static/krasia-tokped-5bd4c11775759235cba67fa05f3abbd2.jpg";